var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 374.56 790.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -53.142,
    y1: 0.5,
    x2: -52.142,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -48.138,
    y1: 0.5,
    x2: -49.138,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -1377.445,
    x2: -1376.445,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -1377.33,
    x2: -1376.33,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -1366.725,
    x2: -1365.725,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -1363.894,
    x2: -1362.894,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0,
    y1: 169.12,
    x2: 1,
    y2: 169.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -1366.725,
    y1: 169.12,
    x2: -1365.725,
    y2: 169.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -1363.894,
    y1: 169.12,
    x2: -1362.894,
    y2: 169.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -52.642,
    y1: 1,
    x2: -52.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -18.234,
    y1: 0.5,
    x2: -17.234,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -18.966,
    x2: -17.966,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -197.688,
    y1: 0.5,
    x2: -196.688,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: -65.385,
    x2: -64.385,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: -711.122,
    y1: 57.085,
    x2: -711.122,
    y2: 58.085,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 40.882,
    y1: 57.085,
    x2: 40.882,
    y2: 58.085,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 190",
    transform: "translate(2072.196 62.952)",
    fill: "none",
    d: "M0 0h374.56v615.564H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 183",
    transform: "translate(1626.31 421.048)",
    fill: "none",
    d: "M0 0h1266.394v299.13H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 186",
    transform: "translate(2071.904 89.15)",
    fill: "none",
    d: "M0 0h375v162.028H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 210",
    d: "M2173.482 132.289h172.5l33.32 41.729h-239.14Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 213",
    d: "m2144.134 116.56 16.531 11.148-65.126 43.786-213.634-34.605V116.56Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 217",
    d: "m2375.333 116.56-16.533 11.148 65.126 43.786 213.634-34.605V116.56Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 189",
    transform: "translate(2072.196 497.448)",
    fill: "none",
    d: "M0 0h374.56v180.637H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 0.5,
    cy: 0.5,
    r: 0.654,
    gradientTransform: "matrix(.642 0 0 1 .179 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#a195ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#9b8cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#8a76f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775cec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 0.5,
    cy: 0.5,
    r: 0.558,
    gradientTransform: "matrix(.819 0 0 1 .091 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a195ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#9b8cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#8a76f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#775cec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 206",
    clipPath: "url(#i)",
    transform: "translate(-2072.196 -7.138)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 204",
    d: "M1559.064 720.178c0-121.153 313.057-219.366 699.231-219.366s699.231 98.213 699.231 219.366",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#c)"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 205",
    d: "M2343.405 125.3h-168.081l-32.466 40.66h233.014Z",
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 187",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile_screen",
    "data-name": "Rectangle 184",
    transform: "translate(2084.382 228.362)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 349.995,
    height: 234.448,
    rx: 24.405,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 349.495,
    height: 233.948,
    rx: 24.155,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 132",
    transform: "translate(2075.96 480.65)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 133",
    transform: "translate(2076.49 201.321)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 134",
    transform: "translate(2125.283 480.65)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 135",
    transform: "translate(2138.304 480.65)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 136",
    transform: "translate(2433.33 480.65)",
    fill: "url(#k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 137",
    transform: "translate(2432.8 201.321)",
    fill: "url(#l)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 138",
    transform: "translate(2384.007 480.65)",
    fill: "url(#m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 139",
    transform: "translate(2370.986 480.65)",
    fill: "url(#n)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 140",
    transform: "translate(2125.283 201.321)",
    fill: "url(#o)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 141",
    transform: "translate(2138.304 201.321)",
    fill: "url(#o)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 142",
    transform: "translate(2384.007 201.321)",
    fill: "url(#p)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 143",
    transform: "translate(2370.986 201.321)",
    fill: "url(#q)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.601,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.601,
    cy: 4.601,
    r: 4.351,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 188",
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 207",
    d: "M2836.439 48.352c0 81.417-258.347 147.418-577.035 147.418s-577.035-66-577.035-147.418",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#s)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 208",
    d: "M2173.482 132.289h172.5l33.32 41.729h-239.14Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 190",
    clipPath: "url(#t)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 209",
    d: "M2173.482 132.289h172.5l33.32 41.729h-239.14Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 144",
    cx: 348.513,
    cy: 94.003,
    rx: 348.513,
    ry: 94.003,
    transform: "translate(1911.711 -40.52)",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8",
    fill: "none",
    d: "M2372.681 165.724h-226.18"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 211",
    d: "m2144.134 116.56 16.531 11.148-65.126 43.786-213.634-34.605V116.56Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 192",
    clipPath: "url(#v)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 145",
    transform: "translate(1911.761 -40.52)",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.513,
    cy: 94.003,
    rx: 348.513,
    ry: 94.003,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.513,
    cy: 94.003,
    rx: 348.263,
    ry: 93.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 212",
    d: "m2154.836 123.777-62.395 37.942 3.1 9.774 65.126-43.786Z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 9",
    transform: "translate(1881.905 123.777)",
    fill: "url(#g)",
    d: "m0 0 210.536 37.942"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 214",
    d: "m2144.134 116.56 16.531 11.148-65.126 43.786-213.634-34.605V116.56Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 215",
    d: "m2375.333 116.56-16.533 11.148 65.126 43.786 213.634-34.605V116.56Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 194",
    clipPath: "url(#x)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 146",
    transform: "translate(1910.68 -40.52)",
    fill: "url(#y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.513,
    cy: 94.003,
    rx: 348.513,
    ry: 94.003,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.513,
    cy: 94.003,
    rx: 348.263,
    ry: 93.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 216",
    d: "m2364.631 123.777 62.395 37.942-3.1 9.774-65.126-43.785Z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    transform: "translate(2427.025 123.777)",
    fill: "url(#A)",
    d: "M210.536 0 0 37.942"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 218",
    d: "m2375.333 116.56-16.533 11.148 65.126 43.786 213.634-34.605V116.56Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 219",
    d: "m2375.225 116.56-16.531 11.148 65.126 43.786 213.634-34.605V116.56Z",
    fill: "none",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 204",
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 220",
    d: "M2415.1 636.64h-310.2l-50.95 41.444h412.107Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    fill: "#d8d8d8",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M2093.384 631.632h333.266v17.156h-333.266z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 221",
    d: "M2437.139 605.132a49.478 49.478 0 0 1-18.64 38.693l-12.963 10.333h-291.519l-12.964-10.333a49.477 49.477 0 0 1-18.639-38.693l31.6 13.584h291.519Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    transform: "translate(2114.017 618.716)",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#E)",
    d: "M0 0h291.519v35.443H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 222",
    d: "M2416.218 570.672a145.256 145.256 0 0 0-113.509-54.62h-86a145.256 145.256 0 0 0-113.509 54.62h313.015Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 223",
    d: "M2392.684 547.039h-265.816a21.62 21.62 0 0 0-18.992 11.288l-25.462 46.8 31.6 13.584h291.519l31.6-13.584-25.462-46.8a21.622 21.622 0 0 0-18.987-11.288Z",
    stroke: "#bebebe",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 224",
    d: "m2205.185 560.693-10.767 44.439h9.979l8.578-44.439Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 225",
    d: "m2217.525 560.693-8.023 44.439h9.979l6.216-44.439Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 226",
    d: "m2195.685 522.1-10.767 20.347h9.979l8.578-20.347Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 227",
    d: "M2208.025 522.1 2200 542.451h9.979l6.221-20.351Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 147",
    cx: 6.201,
    cy: 6.201,
    r: 6.201,
    transform: "translate(2223.638 530.049)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 228",
    d: "m2259.068 531.28-5.7-4.588-5.7-4.588h22.81l-5.7 4.588Z",
    fill: "#775cec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 229",
    d: "m2259.068 542.451 5.7-4.588 5.7-4.588h-22.81l5.7 4.588Z",
    fill: "#775cec"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 230",
    d: "M2286.387 560.693h-54.637l-6.054 44.439h66.744Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 231",
    d: "m2229.139 602.127 5.235-38.429h49.39l5.236 38.429Z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobile_next_video_button",
    "data-name": "Group 199",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 148",
    cx: 36.641,
    cy: 22.22,
    rx: 36.641,
    ry: 22.22,
    transform: "translate(2327.361 560.693)",
    stroke: "#666",
    strokeWidth: 3,
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 232",
    d: "M2364 602.127c-18.232 0-33.636-8.8-33.636-19.214S2345.769 563.7 2364 563.7s33.636 8.8 33.636 19.215-15.402 19.212-33.636 19.212Z",
    stroke: "#bebebe",
    fill: "url(#F)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 233",
    d: "m2312.951 560.693 10.767 44.439h-9.979l-8.578-44.439Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 234",
    d: "m2300.612 560.693 8.023 44.439h-9.979l-6.216-44.439Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 235",
    d: "m2322.451 522.1 10.767 20.347h-9.979l-8.578-20.347Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 236",
    d: "m2310.112 522.1 8.023 20.347h-9.979l-6.216-20.347Z",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 149",
    cx: 6.201,
    cy: 6.201,
    r: 6.201,
    transform: "translate(2282.096 530.049)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 200",
    stroke: "#666",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "m2331.724 530.825 6.866 11.626h10.3Z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 238",
    d: "m2186.372 530.825-6.866 11.626h-10.3Z",
    fill: "url(#J)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 239",
    d: "m2354.12 571.963 4.944 19.051 23.315-11.338Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobile_prev_video_button",
    "data-name": "Group 201",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 150",
    cx: 36.641,
    cy: 22.22,
    rx: 36.641,
    ry: 22.22,
    transform: "translate(2117.495 560.693)",
    stroke: "#666",
    strokeWidth: 3,
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 240",
    d: "M2154.135 602.127c18.233 0 33.637-8.8 33.637-19.214s-15.4-19.215-33.637-19.215-33.635 8.8-33.635 19.215 15.4 19.214 33.635 19.214Z",
    stroke: "#bebebe",
    fill: "url(#F)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "m2164.017 571.963-4.944 19.051-23.315-11.338Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "mobile_play_button",
    "data-name": "Ellipse 151",
    cx: 15.713,
    cy: 12.865,
    rx: 15.713,
    ry: 12.865,
    transform: "translate(2243.336 569.594)",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Play Now",
    transform: "translate(2238.729 583.907)",
    fontSize: 6.414,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 0
  }, "Play Now")))))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7",
    fill: "none",
    d: "M364.673 0v790.404H10.756V0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8",
    fill: "none",
    d: "M354.352 10.321v769.762H21.077V10.321z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBgMobile);
export default __webpack_public_path__ + "static/media/video_bg_mobile.de4daa3d.svg";
export { ForwardRef as ReactComponent };